<div
  class="tab-pane fade flex-even active show"
  id="accountMoves"
  role="tabpanel"
  aria-labelledby="accountMoves-tab"
>
@if (context) {
  <app-account-moves-tab
    [accountMoves]="accountMoves"
    [context]="context"
    [isClient]="isClient"
    (refreshRequested)="onRefresh()"
  />
}
</div>
